import { hex2rgb, rgb2hsl } from "../../helpers/utils/colors";
import { isChipColorConfig, isChipColorConfigFull } from "./Chip.types";
export function selectChipColors(selected, disabled, appearance) {
  // Disabled is always the same, regardless of custom appearance config.
  if (disabled) {
    return {
      "--chip-bg": "var(--color-bg-neutral-secondary)",
      "--chip-bg-hover": "var(--color-bg-neutral-secondary)",
      "--chip-border": "var(--color-bg-neutral-secondary)",
      "--chip-content": "var(--color-content-tertiary)"
    };
  }

  // Check if we are given a custom appearance config and use it if so.
  if (isChipColorConfig(appearance)) {
    try {
      const colorConfig = generateColorConfig(appearance);
      return {
        "--chip-bg": selected ? colorConfig.light.main : colorConfig.light.bg,
        "--chip-bg-hover": colorConfig.light.bgActive,
        "--chip-border": selected ? colorConfig.light.main : colorConfig.light.border,
        "--chip-content": selected ? "var(--color-content-primary-inverted)" : appearance.light.main,
        "--chip-bg-dark": selected ? colorConfig?.dark?.main : colorConfig?.dark?.bg,
        "--chip-bg-hover-dark": colorConfig?.dark?.bgActive,
        "--chip-border-dark": selected ? colorConfig?.dark?.main : colorConfig?.dark?.border,
        "--chip-content-dark": selected ? "var(--color-content-primary-inverted)" : colorConfig?.dark?.main
      };
    } catch (e) {
      // eslint-disable-next-line no-console -- expected
      console.error("Error in generateColorConfig", e);
    }
  } else {
    return {
      "--chip-bg": getColorProperty("bg", appearance, {
        selected,
        active: false
      }),
      "--chip-bg-hover": getColorProperty("bg", appearance, {
        selected,
        active: true
      }),
      "--chip-border": getColorProperty("border", appearance, {
        selected,
        active: false
      }),
      "--chip-content": getColorProperty("content", appearance, {
        selected,
        active: false
      })
    };
  }
  return undefined;
}
function getColorProperty(colorGroup, appearance, opts) {
  if (opts.selected && colorGroup === "content") {
    return "var(--color-content-primary-inverted)";
  }
  if (appearance === "neutral" && colorGroup === "content") {
    return `var(--color-${colorGroup}${opts.active ? "-active" : ""}-${opts.selected ? "primary" : "secondary"})`;
  }
  return `var(--color-${colorGroup}${opts.active ? "-active" : ""}-${appearance}-${opts.selected ? "primary" : "secondary"})`;
}
export function generateColorConfig(inputConfig) {
  if (isChipColorConfigFull(inputConfig)) {
    return inputConfig;
  }
  const mainColorRGB = hex2rgb(inputConfig.light.main);

  // bg-color opacity 0.12
  const bg = `rgba(${mainColorRGB?.r}, ${mainColorRGB?.g}, ${mainColorRGB?.b}, 0.12)`;

  // bg-color active opacity 0.24
  const bgActive = `rgba(${mainColorRGB?.r}, ${mainColorRGB?.g}, ${mainColorRGB?.b}, 0.24)`;

  // border color opacity 0.48
  const border = `rgba(${mainColorRGB?.r}, ${mainColorRGB?.g}, ${mainColorRGB?.b}, 0.48)`;

  // dark - convert to hsl, change lightness to 75
  const darkMain = rgb2hsl([mainColorRGB?.r, mainColorRGB?.g, mainColorRGB?.b]);
  darkMain.l = 75;
  const darkMainHSL = `hsl(${darkMain.h}, ${darkMain.s}%, ${darkMain.l}%)`;

  // apply same logic with opacity as for light mode
  const darkBg = `hsla(${darkMain.h}, ${darkMain.s}%, ${darkMain.l}%, 0.12)`;
  const darkBgActive = `hsla(${darkMain.h}, ${darkMain.s}%, ${darkMain.l}%, 0.24)`;
  const darkBorder = `hsla(${darkMain.h}, ${darkMain.s}%, ${darkMain.l}%, 0.48)`;
  return {
    light: {
      main: inputConfig.light.main,
      bg,
      bgActive,
      border
    },
    dark: {
      main: darkMainHSL,
      bg: darkBg,
      bgActive: darkBgActive,
      border: darkBorder
    }
  };
}